(function () {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const sectionEl = document.querySelector('[data-section-type="product-template"]');
  if (!sectionEl) {
    console.error('[product-template-cart] product-template section not found');
    return;
  }

  const formId = 'AddToCartForm--' + sectionEl.dataset.sectionId;

  const OPENDOTS_GIFT_SYNC = {
    'opendots-2': [
      'shokz_earbuds-accessory_pianokeys',
      'shokz_earbuds-accessory_nacre',
      'shokz_clip-on-earbud-carrying-case_black',
      'shokz_clip-on-earbud-carrying-case_white',
      '360-day-worry-free-service-for-opendots-2',
    ],
    'opendots-air': [
      'shokz_earbuds-accessory_lilac',
      'shokz_clip-on-earbud-carrying-case_black',
      'shokz_clip-on-earbud-carrying-case_white',
    ],
  };

  const FREE_GIFT_GLOBAL_MAP = [
    { selector: '.add-to-cart-form-free-gift31', idKey: 'free_gift5_id', qtyKey: 'free_gift5_quantity' },
    { selector: '.add-to-cart-form-free-gift34', idKey: 'free_gift9_id', qtyKey: 'free_gift9_quantity' },
  ];

  function getForm() {
    return document.getElementById(formId);
  }

  function getAtcButtons() {
    return document.querySelectorAll(
      '.product_template_new [data-dawn-atc], .product_template_new [data-dawn-atc-sticky]'
    );
  }

  function setButtonState(button, state) {
    if (!button) return;
    button.classList.remove('is-adding', 'is-added');
    if (state === 'adding') button.classList.add('is-adding');
    if (state === 'added') button.classList.add('is-added');
  }

  function getSelectedColor() {
    const activeSwatch = document.querySelector(
      '.product_template_new .options-color-wrapper.active .option-item[data-value]'
    );
    if (activeSwatch) {
      return activeSwatch.getAttribute('data-value') || '';
    }

    const checked = document.querySelector(
      '.product_template_new .single-option-radio input:checked'
    );
    if (checked) {
      return checked.value || '';
    }

    return '';
  }

  function syncHiddenFreeGiftVariant(selectedColor) {
    const color = selectedColor || getSelectedColor();
    const containers = document.querySelectorAll('.free-gift-product');
    if (!containers.length) return;

    containers.forEach((container) => {
      const wrappers = Array.from(container.querySelectorAll('.variant-wrapper'));
      if (!wrappers.length) return;

      let matched = false;
      wrappers.forEach((wrapper) => {
        const tagAll = (wrapper.dataset.tagall || wrapper.dataset.tag || '').trim();
        const parts = tagAll.split('/').map((part) => part.trim());
        const tag = (wrapper.dataset.tag || '').trim();
        const isMatch = color && (parts.includes(color) || tag === color);
        wrapper.classList.toggle('active', isMatch);
        if (isMatch) matched = true;
      });

      if (!matched) {
        wrappers.forEach((wrapper, index) => {
          wrapper.classList.toggle('active', index === 0);
        });
      }
    });
  }

  window.syncHiddenFreeGiftVariant = syncHiddenFreeGiftVariant;

  function getActiveFreeGiftMeta(formSelector) {
    const forms = document.querySelectorAll(formSelector);
    if (!forms.length) return null;

    let form = null;
    forms.forEach((candidate) => {
      const wrapper = candidate.closest('.variant-wrapper');
      if (wrapper && wrapper.classList.contains('active')) {
        form = candidate;
      }
    });
    if (!form) form = forms[0];

    const input = form.querySelector('input[name="id"]');
    if (!input) return null;

    const qty = parseInt(input.getAttribute('data-quantity'), 10);
    return {
      id: input.value,
      quantity: Number.isNaN(qty) ? 0 : qty,
    };
  }

  function refreshFreeGiftGlobalsFromDom() {
    FREE_GIFT_GLOBAL_MAP.forEach((entry) => {
      const meta = getActiveFreeGiftMeta(entry.selector);
      if (!meta || !meta.id) return;
      window[entry.idKey] = meta.id;
      window[entry.qtyKey] = meta.quantity;
    });
  }

  function syncVariantIdFromUI(form) {
    const scope = form.closest('.product_template_new') || document;
    const select = form.querySelector('select[name="id"]');
    if (!select) return '';

    const activeSwatch = scope.querySelector('.options-color-wrapper.active[data-var_id]');
    if (activeSwatch && activeSwatch.dataset.var_id) {
      select.value = activeSwatch.dataset.var_id;
      return activeSwatch.dataset.var_id;
    }

    const checked = form.querySelectorAll('.single-option-selector__radio:checked[data-var_id]');
    if (checked.length === 1) {
      select.value = checked[0].dataset.var_id;
      return checked[0].dataset.var_id;
    }

    if (checked.length > 1) {
      const colorRadio = Array.from(checked).find((radio) => {
        const label = form.querySelector(`label[for="${radio.id}"]`);
        return label && label.classList.contains('options-color-wrapper');
      });
      const variantId = colorRadio
        ? colorRadio.dataset.var_id
        : checked[checked.length - 1].dataset.var_id;
      if (variantId) {
        select.value = variantId;
        return variantId;
      }
    }

    const activeSize = scope.querySelector('.toggle-product-size-item.active[data-var_id]');
    if (activeSize && activeSize.dataset.var_id) {
      select.value = activeSize.dataset.var_id;
      return activeSize.dataset.var_id;
    }

    return select.value;
  }

  function collectBenefitItems() {
    // return Array.from(
    //   document.querySelectorAll(
    //     '.purchase-block .benefit-wrapper:not(.is-variant-hidden) .product-wrapper.active[data-id]'
    //   )
    // )
    //   .map((el) => parseInt(el.dataset.id, 10))
    //   .filter((id) => id > 0);

    // 临时关闭 benefit 一起加购：
    return [];
  }

  function collectHiddenFreeGiftItems(existingIds) {
    // const ids = new Set(existingIds);
    // const items = [];

    // FREE_GIFT_GLOBAL_MAP.forEach((entry) => {
    //   const meta = getActiveFreeGiftMeta(entry.selector);
    //   if (!meta || !meta.id) return;
    //   const giftId = parseInt(meta.id, 10);
    //   if (giftId > 0 && !ids.has(giftId)) {
    //     ids.add(giftId);
    //     items.push(giftId);
    //   }
    // });

    // return items;
    
    // 临时关闭 benefit 一起加购：
    return [];
  }

  function buildCartItems(form) {
    const variantId = parseInt(syncVariantIdFromUI(form), 10);
    if (!variantId) return null;

    const items = [{ id: variantId, quantity: 1 }];
    const idSet = new Set([variantId]);

    collectBenefitItems().forEach((giftId) => {
      if (!idSet.has(giftId)) {
        idSet.add(giftId);
        items.push({ id: giftId, quantity: 1 });
      }
    });

    collectHiddenFreeGiftItems(idSet).forEach((giftId) => {
      items.push({ id: giftId, quantity: 1 });
    });

    return items;
  }

  function openCartDrawer(response) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (response && response.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(response);
    } else if (typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  function addToCartWithBenefits(form) {
    const items = buildCartItems(form);
    if (!items) {
      return Promise.reject(new Error('missing_variant_id'));
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    }).then((res) => {
      if (!res.ok) {
        return res.json().then((err) => Promise.reject(err));
      }
      return res.json();
    });
  }

  function runFreeGiftSync() {
    return new Promise((resolve) => {
      refreshFreeGiftGlobalsFromDom();
      const syncFn = window.free_gift_change_num;
      if (typeof syncFn !== 'function') {
        resolve(null);
        return;
      }
      syncFn('after_atc', function (cart) {
        resolve(cart);
      });
    });
  }

  function handleAddToCartError(err) {
    getAtcButtons().forEach((btn) => setButtonState(btn, null));
    if (typeof ShopifyAPI !== 'undefined' && typeof ShopifyAPI.onError === 'function' && err) {
      const xhr = {
        responseText: typeof err === 'object' ? JSON.stringify(err) : String(err),
        status: err.status || 422,
      };
      ShopifyAPI.onError(xhr);
    }
  }

  function handleAddToCart(triggerButton) {
    const form = getForm();
    if (!form) {
      console.error('[product-template-cart] form not found:', formId);
      return;
    }

    const buttons = getAtcButtons();
    buttons.forEach((btn) => setButtonState(btn, 'adding'));
    if (triggerButton) setButtonState(triggerButton, 'adding');

    syncVariantIdFromUI(form);
    syncHiddenFreeGiftVariant(getSelectedColor());

    addToCartWithBenefits(form)
      .then((response) => {
        if (typeof product_page_ga4_deal === 'function' && window.jQuery) {
          var d1 = jQuery(".product-form__item-1 input:checked + label .product-data-div").attr('data-product-data'),
              d2 = jQuery(".product-form__item-2 input:checked + label .product-data-div").attr('data-product-data');
          if (d1) {
            var p = d1.split('::');
            if (d2) { var p2 = d2.split('::'); p[1] = p[8] + '-' + p[6] + '-' + p2[7]; }
            product_page_ga4_deal(p, (triggerButton && triggerButton.textContent || '').trim(), 'add_to_cart');
          }
        }
        openCartDrawer(response);
        return runFreeGiftSync().then((cartResponse) => {
          if (cartResponse) {
            openCartDrawer(cartResponse);
          }
          getAtcButtons().forEach((btn) => setButtonState(btn, 'added'));
        });
      })
      .catch((err) => {
        console.error('[product-template-cart] add failed', err);
        handleAddToCartError(err);
      });
  }

  function countMainProductQty(cart, mainHandle) {
    return cart.items.reduce((total, item) => {
      if (item.handle === mainHandle) {
        return total + item.quantity;
      }
      return total;
    }, 0);
  }

  function buildOrphanGiftUpdates(cart) {
    const updates = {};

    Object.keys(OPENDOTS_GIFT_SYNC).forEach((mainHandle) => {
      const mainQty = countMainProductQty(cart, mainHandle);
      if (mainQty > 0) return;

      const giftHandles = OPENDOTS_GIFT_SYNC[mainHandle];
      cart.items.forEach((item) => {
        if (giftHandles.includes(item.handle)) {
          updates[item.variant_id] = 0;
        }
      });
    });

    return updates;
  }

  function postCartUpdates(updates) {
    const parts = Object.keys(updates).map(
      (id) => `updates[${id}]=${updates[id]}`
    );
    if (!parts.length) return Promise.resolve(null);

    const sectionsQuery =
      '&sections=cart-drawer,cart-icon-bubble&sections_url=' +
      encodeURIComponent(window.location.pathname);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: parts.join('&') + sectionsQuery,
    }).then((res) => {
      if (!res.ok) return null;
      return res.json();
    });
  }

  window.syncBenefitOrphanGifts = function () {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then((res) => res.json())
      .then((cart) => {
        const updates = buildOrphanGiftUpdates(cart);
        return postCartUpdates(updates);
      })
      .then((cartResponse) => {
        if (cartResponse) {
          openCartDrawer(cartResponse);
        }
      })
      .catch((err) => {
        console.error('[product-template-cart] syncBenefitOrphanGifts failed', err);
      });
  };

  function onAtcClick(evt) {
    const button = evt.target.closest('[data-dawn-atc], [data-dawn-atc-sticky]');
    if (!button || !button.closest('.product_template_new')) return;

    evt.preventDefault();
    evt.stopPropagation();

    if (button.disabled) return;
    handleAddToCart(button);
  }

  function init() {
    const form = getForm();
    if (!form) {
      console.error('[product-template-cart] failed to bind, form missing:', formId);
      return;
    }

    if (document.documentElement.dataset.productTemplateCartBound === 'true') return;
    document.documentElement.dataset.productTemplateCartBound = 'true';

    document.addEventListener('click', onAtcClick, true);

    form.addEventListener(
      'submit',
      function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        handleAddToCart(null);
      },
      true
    );

    console.info('[product-template-cart] bound', formId);
  }

  window.submitProductFormAjax = function () {
    handleAddToCart(null);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
